// <head> metadata for UnbreakableAiWorkflowsBauplanPage (https://www.dbos.dev/unbreakable-ai-workflows-bauplan).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Webcast: Composing Unbreakable AI Workflows',
    },
    {
      name: 'description',
      content:
        'Bauplan co-founders Jacopo Tagliabue and Ciro Greco, and DBOS co-founders Qian Li and Peter Kraft present Python developers with a reference architecture for a reliable autonomous AI platform.',
    },
    {
      property: 'og:title',
      content: 'Webcast: Composing Unbreakable AI Workflows',
    },
    {
      property: 'og:description',
      content:
        'Bauplan co-founders Jacopo Tagliabue and Ciro Greco, and DBOS co-founders Qian Li and Peter Kraft present Python developers with a reference architecture for a reliable autonomous AI platform.',
    },
    {
      property: 'og:image',
      content:
        'https://www.dbos.dev/assets/images/688b761c3c2ff25ea16946d1_Composing-Unbreakable-AI-Workflows-Sept10.png',
    },
    {
      name: 'twitter:title',
      content: 'Webcast: Composing Unbreakable AI Workflows',
    },
    {
      name: 'twitter:description',
      content:
        'Bauplan co-founders Jacopo Tagliabue and Ciro Greco, and DBOS co-founders Qian Li and Peter Kraft present Python developers with a reference architecture for a reliable autonomous AI platform.',
    },
    {
      name: 'twitter:image',
      content:
        'https://www.dbos.dev/assets/images/688b761c3c2ff25ea16946d1_Composing-Unbreakable-AI-Workflows-Sept10.png',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/unbreakable-ai-workflows-bauplan',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
